import { Injectable, Injector } from '@angular/core';


@Injectable()
export class CommonUtilityService {

	constructor() {}

	getArrayRange(arr) {
		let min = arr[0];
		let max = arr[0];
		const range = [];
		for (let i = 0; i < arr.length; i++) {
			if (min > arr[i]) {
				min = arr[i];
			}
			if (max < arr[i]) {
				max = arr[i];
			}
		}
		range.push(min);
		range.push(max);
		return range;
	}
	arrayToObjectByFirstProp(data: object[]): { [prop: string]: any} {
		const convertedObj: any = {};
		let prop: string;
		for (let i = 0; i < data.length; i++) {
			prop = Object.keys(data[i])[0];
			convertedObj[prop] = data[i][prop];
		}
		return convertedObj;
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/common-utility.ts